export default class FormatacaoHora {
  public static formataHoraDecimal(hora: any) {
    const sinalNegativo = '-';

    // Verifica se houve entrada de valor
    if (hora === null || hora === 0) {
      // Nenhum valor entrou, retorna null
      return '00:00';
    }
    if (hora === '-') {
      return '-';
    }

    let flagSinalNegativo = ''; // Flag de sinal de negativo

    hora = hora.replace(',', '.');
    hora = parseFloat(hora);

    // Verifica se o valor é negativo
    if (hora < 0) {
      hora *= -1; // Passa o valor para positivo
      flagSinalNegativo = sinalNegativo; // Ajusta o flag de sinal para negativo
    }

    let parteInteiraHoras = Math.floor(hora); // Parte inteira das horas
    const minutosFracionados = (hora - parteInteiraHoras) * 60; // Minutos fracionados
    let parteInteiraMinutos = Math.round(minutosFracionados); // Parte inteira dos minutos

    if (parteInteiraMinutos >= 60) {
      parteInteiraHoras++;
      parteInteiraMinutos -= 60;
    }

    return `${flagSinalNegativo + (parteInteiraHoras < 10 ? `0${parteInteiraHoras}` : parteInteiraHoras)
    }:${
      parteInteiraMinutos < 10 ? `0${parteInteiraMinutos}` : parteInteiraMinutos}`;
  }

  public static getDateInReportFormat(date: string): string {
    const dateArray = date.split('/');
    const day = dateArray[0];
    const month = dateArray[1];
    const year = dateArray[2];

    const dayOfWeek = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
    ).getDay();

    const dayOfWeekStr = FormatacaoHora.getDayOfWeekAbbreviation(dayOfWeek);

    const formattedDate = `${day}/${month} - ${dayOfWeekStr}`;

    return formattedDate;
  }

  public static getDayOfWeekAbbreviation(dayOfWeekIndex: number): string {
    const abbreviations = [
      'Dom', 'Seg', 'Ter', 'Qua',
      'Qui', 'Sex', 'Sab',
    ];

    return abbreviations[dayOfWeekIndex];
  }
}
